import { Device } from "@capacitor/device"; // Importa el módulo Device si está en el mismo directorio o especifica la ruta correcta

const isIosNative = {
  logDeviceInfo: async () => {
    try {
      const info = await Device.getInfo();
      return info.platform === "ios";
    } catch (error) {
      return false;
    }
  },
};

export default isIosNative;
